// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".live-channel[data-v-4fb07a46]{height:100%;height:64px;border-bottom:3px solid #4a5069;white-space:nowrap;overflow-x:scroll;overflow-y:hidden}.live-channel[data-v-4fb07a46]::-webkit-scrollbar{display:none}.live-channel a[data-v-4fb07a46]{display:inline-block;height:64px;line-height:64px;font-size:16px;color:#999;margin-right:36px;cursor:pointer}.live-channel a.active[data-v-4fb07a46]{color:#333;font-weight:700;font-size:24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
